
  import { StreamContentDiff } from '@/types';
  import Vue, {PropType} from 'vue'
  const _ = require('lodash');
  export default Vue.extend({
    name: 'StreamChangeView',
     data() {
      return {
       
      };
    },
    components :{
    },
    methods: {
     
    },
    computed: {
      
  
    },
    props:{
      streamChanges: {type : Object as PropType<StreamContentDiff>, required : true}
    }
    
  })
  